<template>
  <div class="auth-block">
    <div class="auth-block__main_title">
      <div class="auth-block__main_title__title">
        ДИЛЕРСКИЙ ПОРТАЛ
      </div>
      <div class="auth-block__main_title__text">
        Размещение заказов на автомобили ГК "СОЛЛЕРС"
      </div>
    </div>
    <div class="auth-block__content">
      <div class="auth-screen">
        <div class="auth-screen__top">
          <div class="auth-screen__top__image-block">
            <img
              class="auth-screen__top__image-block__image"
              src="@/assets/logo.png"
              alt="Sollers Ford SVO"
              width="220"
              height="66"
            >
          </div>
          <div class="auth-screen__top__image-block">
            <img
              class="auth-screen__top__image-block__image"
              src="@/assets/loginImage.png"
              alt="Sollers Ford SVO"
              height="80"
            >
          </div>
        </div>
        <div
          v-if="isPasswordReset"
          class="lost-block"
        >
          <div
            v-if="!isLetterSent"
            class="alert alert-warning"
          >
            <b>Внимание!</b> Если вы забыли пароль, введите E-Mail, привязанный к вашей учетной записи. Ссылка для сброса пароля будет выслана по указанному адресу.
          </div>
          <div
            v-else
            class="alert alert-info"
          >
            <b>Готово!</b> Письмо с ссылкой для сброса пароля было выслано на Ваш email.
          </div>
        </div>
        <div class="auth-screen__middle">
          <form
            v-if="!isPasswordReset || !isLetterSent"
            class="auth-form"
            novalidate
            @submit.prevent="processRequest"
          >
            <div
              class="form-group mb-3"
              :class="{'mb-4': isPasswordReset}"
            >
              <input
                id="login-data"
                placeholder="E-mail"
                v-model="login"
                type="text"
                class="form-control"
                autocomplete="username"
              >
              <div
                class="invalid-feedback"
                :class="{'d-none': !errors.login}"
              >
                {{ errors.login }}
              </div>
            </div>
            <div
              v-if="!isPasswordReset"
              class="form-group mb-4"
            >
              <input
                id="password-data"
                placeholder="Пароль"
                v-model="password"
                type="password"
                class="form-control"
                autocomplete="current-password"
              >
              <div
                v-if="errors.password"
                class="invalid-feedback"
              >
                {{ errors.password }}
              </div>
            </div>
            <div
              v-if="needCaptcha"
              class="mb-3"
            >
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="sitekey"
                :load-recaptcha-script="true"
                @verify="verify"
                @expired="onCaptchaExpired"
              />
            </div>
            <div
              v-if="errors.unauthorized && !errors.password && !processing"
              class="invalid-feedback mb-3"
            >
              {{ errors.unauthorized }}
            </div>
            <div class="auth-form__button">
              <button
                type="submit"
                class="btn btn-primary btn-block"
                :disabled="processing"
              >
                {{ isPasswordReset ? 'Выслать' : 'Войти' }}
              </button>
            </div>
          </form>
        </div>
        <div class="auth-screen__bottom">
          <div class="lost-access">
            <a
              class="lost-access__link interactive"
              href="javascript:void(0);"
              @click="switchMode"
            >
              {{ isPasswordReset? 'Вернуться к авторизации' : 'Восстановить пароль' }}
            </a>
          </div>
        </div>
      </div>
      <div class="auth-banner">
        <img
          class="auth-banner__img"
          src="@/assets/banner.png"
        />
      </div>
      <warning />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';
import Warning from '@/components/sign-in/AuthWarning.vue';

export default {
  name: 'SignIn',
  components: {
    Warning,
    VueRecaptcha,
  },
  data() {
    return {
      sitekey: this.$config.CONFIG_CAPTCHA_SITEKEY,
      login: '',
      password: '',
      saveMe: false,
      processing: false,
      formHasErrors: false,
      isPasswordReset: false,
      isLetterSent: false,
      needCaptcha: false,
      recaptchaToken: false,
      errors: {
        login: '',
        password: '',
        unauthorized: '',
      },
    };
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        const defaultInterface = this.user.interfaces.find(it => it.includes('default'));

        if (!defaultInterface) {
          this.$router.push('/');
          return;
        }

        if (defaultInterface === 'default-SVO') {
          window.location.href = `/${this.$config.PAGE_SVO_ORDERS}`;
        }

        this.$router.push('/');
      },
    },
  },
  methods: {
    switchMode() {
      this.isPasswordReset = !this.isPasswordReset;
      this.isLetterSent = false;

      this.formHasErrors = false;
      Object.assign(this.$data.errors, this.$options.data().errors);
    },
    processRequest() {
      if (this.isPasswordReset) {
        this.resetPassword();
        return;
      }

      this.signIn();
    },
    async resetPassword() {
      this.validateForm();

      if (this.formHasErrors) {
        return;
      }

      this.processing = true;

      try {
        await this.$http.post(`users/1.0/reset-password/${this.login}`);
        this.isLetterSent = true;
      } catch (error) {
        this.errors.email = error.response ? error.response.data.error : error.message;
      } finally {
        this.processing = false;
      }
    },
    verify(recaptchaToken) {
      this.recaptchaToken = recaptchaToken;
    },
    async signIn() {
      this.validateForm();

      if (this.formHasErrors) {
        this.$refs.recaptcha.reset();
        return;
      }

      this.processing = true;

      try {
        await this.$http.post('users/1.0/login', {
          email: this.login,
          password: this.password,
          'g-recaptcha-response': this.recaptchaToken,
        });

        if (this.$route.query.from) {
          window.location.href = `/${this.$route.query.from}`;
          return;
        }

        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
          return;
        }

        // handle redirtects in watcher after getting user
      } catch (e) {
        if (e.response.status === 401) {
          this.errors.unauthorized = e.response.data.error.message;
        }
        if (e.response.data.error.needCaptcha) {
          this.needCaptcha = true;
          this.$refs.recaptcha.reset();
        }
      } finally {
        this.processing = false;
        this.password = '';
      }
    },
    validateForm() {
      this.formHasErrors = false;
      this.errors.login = '';
      this.errors.password = '';

      if (!this.login) {
        this.errors.login = 'Необходимо указать email';
        this.formHasErrors = true;
      }

      if (!this.password && !this.isPasswordReset) {
        this.errors.password = 'Необходимо указать пароль';
        this.formHasErrors = true;
      }
    },
    onCaptchaExpired() {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
    },
  },
};
</script>
